import styled from 'styled-components';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import {
    device
} from '../../../style/breakpoints';

export const FloatingCardStyled = styled(Card)`
bottom: 5px;
left: 5px;
position: absolute !important;
right:5px;
top:5px;
z-index: 1201;
    box-shadow: rgba(0, 0, 0, 0.2) 0px 3px 3px -2px, rgba(0, 0, 0, 0.14) 0px 3px 4px 0px, rgba(0, 0, 0, 0.12) 0px 1px 8px 0px;
    @media ${device.tablet} {
        bottom:0;
        left:0;
        right:0;
        // top:20px;
    }
`

export const FloatingCardInner = styled(CardContent)`
    display: flex;
    flex-flow: column;
    flex: 1 1 auto;
    height: 100%;
`